import React from 'react';
import {EvhubFeatureAppDependencies} from './';

export const FeatureServicesContext = React.createContext<
  EvhubFeatureAppDependencies | undefined
>(undefined);

export function useFeatureServices(): EvhubFeatureAppDependencies {
  const featureServices = React.useContext(FeatureServicesContext);

  if (!featureServices) {
    throw new Error('No featureServices context value was provided.');
  }

  return featureServices;
}
